// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"9e710479","129":"3cab0b84","488":"a2a65e2b","518":"4384edc4","588":"3f6b7ae2","606":"5058a828","644":"2e1841c1","725":"2ed07059","952":"47c11874"}[chunkId] + ".chunk.js";
};